<app-page-header title="Választási szervek"></app-page-header>

<div class="content my-3 col-lg-10 mx-auto">
  <b>A választási iroda</b>
  <ul>
    <li>vezetője: Dr. Horváth József jegyző</li>
    <li>
      elérhetőségei: 2890 Tata, Kossuth tér 1. - e-mail:
      <a href="mailto:jegyzoititkarsag@tata.hu">jegyzoititkarsag@tata.hu</a>
    </li>
  </ul>
  <ul>
    <li>A választási iroda vezetőjének</li>
  </ul>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b
    ><a
      href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/DM határozat ajánlások száma.pdf"
      target="_blank"
      >mandátumok számának megállapításáról szóló határozata</a
    ></b
  ><br />
  ><br /><b>A választási bizottság</b>
  <ul>
    <li>tagjainak és póttagjainak nevei:</li>
  </ul>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pénzesné
  Novotni Erika - elnökk<br />
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbspStegmayer
  Viktorné - elnökhelyettes<br />
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gulyásné
  Dobos Katalin - tag<br />
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbspSchmidt
  Marianna - tag<br />
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Schmidt
  Mónika - tag<br />
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Aradi
  Péterné - póttag<br />
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Stegmayer
  Flóra - póttag<br /><br />
  <ul>
    <li>
      elérhetőségei: 2897 Dunaszentmiklós, Petőfi S. u. 52. - e-mail:
      <a href="mailto:ph@dunaszentmiklos.hu">ph@dunaszentmiklos.hu</a>
    </li>
  </ul>
  <ul>
    <li>Ülésről készült jegyzőkönyv:</li>
  </ul>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b
    ><a
      href="https://dunaszentmiklos.hu/assets/dokumentumok/uploads/2024/04/Jegyzőkönyv XII.4..pdf"
      target="_blank"
      >2023.11.29</a
    ></b
  >
</div>
